import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getQuarterlyReports, updateReportConfig, sendReportApi, generateAllReportsApi } from '../value.api';

export function useQuarterlyReports(quarter?: string) {
  return useQuery({
    queryKey: ['value', 'quarterly-reports', quarter],
    queryFn: () => getQuarterlyReports(quarter),
  });
}

export function useUpdateReportConfig() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ gln, config }: { gln: string; config: { recipientName: string; recipientEmail: string } }) =>
      updateReportConfig(gln, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['value', 'quarterly-reports'] });
    },
  });
}

export function useSendReport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (gln: string) => sendReportApi(gln),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['value', 'quarterly-reports'] });
    },
  });
}

export function useGenerateAllReports() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (quarter?: string) => generateAllReportsApi(quarter),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['value', 'quarterly-reports'] });
    },
  });
}
